import React from "react";
import PageHeader from "../../components/PageHeader";
import CategoryListComponent from "../../components/Category/CategoryList";

class CategoryList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Categories"
                            Breadcrumb={[
                                { name: "Categories", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CategoryListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryList;
